import React, { useState, useEffect, useRef } from 'react'
import { debounce } from 'lodash'
import { useDispatch } from 'react-redux'
import { setLayoutChanging } from '../../../redux/slices/filterSlice'
import FilterSearchBox from './filter_components/FilterSearchBox'
import SortDropdown from './filter_components/dropdowns/SortDropdown'
import FilterDropdown from './filter_components/dropdowns/FilterDropdown'
import MoreFilterDropdown from './filter_components/dropdowns/MoreFilterDropdown'
import ClearAll from './filter_components/ClearAll'
import MenuGrid from '../../ui/MenuGrid'
import MenuItem from '../../ui/MenuItem'

const BaseFilter = ({ children }) => {
  const dispatch = useDispatch()
  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const resizeTimeoutRef = useRef(null)
  const layoutChangingRef = useRef(false)

  // Detect screen size changes
  useEffect(() => {
    const debouncedCheckScreenSize = debounce(() => {
      const newIsSmallScreen = window.innerWidth < 1024;
      
      if (isSmallScreen !== newIsSmallScreen) {
        dispatch(setLayoutChanging(true));
        layoutChangingRef.current = true;
        
        setIsSmallScreen(newIsSmallScreen);
        
        setTimeout(() => {
          dispatch(setLayoutChanging(false));
          layoutChangingRef.current = false;
        }, 1000);
      }
    }, 500);

    const handleResize = () => {
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
      
      if (!layoutChangingRef.current) {
        dispatch(setLayoutChanging(true));
        layoutChangingRef.current = true;
      }
      
      debouncedCheckScreenSize();
    };

    const initialScreenSize = window.innerWidth < 1024;
    setIsSmallScreen(initialScreenSize);

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      debouncedCheckScreenSize.cancel();
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
      if (layoutChangingRef.current) {
        dispatch(setLayoutChanging(false));
      }
    };
  }, [dispatch, isSmallScreen]);

  // Search and Sort Section
  const topSection = (
    <>
      <MenuItem>
        <FilterSearchBox maxWidth='none' />
      </MenuItem>
      <MenuItem>
        <SortDropdown maxWidth='none' />
      </MenuItem>
    </>
  )

  // All Filters in a single scrollable row
  const filterSection = (
    <>
      <MenuItem>
        <FilterDropdown 
          type='productType' 
          maxWidth='none' 
          disabled={true} 
          defaultValue='designer' 
        />
      </MenuItem>
      <MenuItem>
        <FilterDropdown 
          type='transactionType' 
          maxWidth='none'
          disabled={false}
        />
      </MenuItem>
      <MenuItem>
        <MoreFilterDropdown 
          type='category'
          disabled={false}
        />
      </MenuItem>
      <MenuItem>
        <MoreFilterDropdown 
          type='size'
          disabled={false}
        />
      </MenuItem>
      <MenuItem>
        <MoreFilterDropdown 
          type='color'
          disabled={false}
        />
      </MenuItem>
    </>
  )

  // Bottom section with children and clear all
  const bottomSection = (
    <>
      <div className='w-full'>{children}</div>
      <div className='flex items-center justify-end w-full flex-wrap'>
        <ClearAll className='mt-2 mb-2' />
      </div>
    </>
  )

  // Single consistent return statement with horizontal layout
  return (
    <MenuGrid
      layout='horizontal'
      topSection={topSection}
      filterSection={filterSection}
      bottomSection={bottomSection}
    />
  )
}

export default BaseFilter
